module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself-large@2x.ad6f33e4.png";